$(document).ready(function(){

  $(document).on("click", ".show_drop_down_menu", function(){
    var id = getId(this.id);
    var parentEl = $(this).parent().closest('.drop_down_data_list');
    $(parentEl).find('.set_title_name').toggleClass("hide");
    // $(parentEl).find('.show_upside_arrow').toggleClass("hide");
    $('#display_drop_down_data_' + id).toggleClass("hide");
  });

  //show category form on clicking edit btn
  $(document).on("click", ".category_edit", function(){
    var id = getId(this.id);
    $("#category_name_" + id).removeAttr('disabled');
    $("#category_auction_type_" + id).removeAttr('disabled');
    $("#category_announce_type_" + id).removeAttr('disabled');
    $("#category_ad_type_" + id).removeAttr('disabled');
    $("#category_icon_" + id).removeAttr('disabled');
    $("#category_info_" + id).removeClass('hide');
    $("#category_tax_rate_" + id).removeAttr('disabled');
    $("#category_with_icon_" + id).addClass("hide");
    $("#category_without_icon_" + id).removeClass("hide");
  });

  $(document).on('click', '.category_remove', function(){
    var id = getId(this.id);
    $("#" + id).remove();
  });

  $(document).on("click", ".category_register", function(){
    $("#category_details").click();
  });

  $(document).on("click", ".category_cancel", function(){
    var id = getId(this.id);
    $("#category_info_" + id).addClass('hide');
  });

});

function getId(id){
  var idArr = id.split("_");
  return idArr[idArr.length - 1];
}

function checkNumericValue(number, decimal_points = 2) {
  if (number){
    return parseFloat(parseFloat(number.toString().replace(' ', '').replace(",", ".")).toFixed(decimal_points));
  }
  else{
    return 0;
  }
}

//show unselect text, hide select text
function set_unselect_text(selectId, unselectId) {
  $(selectId).addClass('hide');
  $(unselectId).removeClass('hide');
}

//show select text, hide unselect text
function set_select_text(selectId, unselectId) {
  $(selectId).removeClass('hide');
  $(unselectId).addClass('hide');
}